import { BaseJs } from '@gate31/core/src/libs/BaseJsComponents';
import { LiquidTemplates } from '@gate31/uikit/common/scripts/liquid-render';
import { InsalesProduct } from '@gate31/feature/InsalesProduct/InsalesProduct';
import { WarehouseProduct } from '@gate31/feature/WarehouseProduct/WarehouseProduct';
import { faro } from '@gate31/faro/src';

class WarehouseProductDeskError extends Error {
    name = 'WarehouseProductDeskError'
}

export class WarehouseProductDesk extends WarehouseProduct {
    static readonly cn = new BaseJs.BuildCn('WarehouseProductDesk');
    static readonly errorMessage =
        `К сожалению, сейчас мы не смогли узнать наличие в интересующих вас магазинах.
        Пожалуйста, попробуйте открыть раздел ещё раз или повторите действия через несколько минут.`;

    product: InsalesProduct;
    trigger?: HTMLElement;

    constructor({ template, product, trigger }: {
        template: keyof LiquidTemplates;
        product: InsalesProduct;
        trigger?: HTMLElement;
    }) {
        super(template);

        this.product = product;
        this.trigger = trigger;

        if (! this.trigger) {
            return;
        }

        this.connectionCallback();
    }

    connectionCallback() {
        this.trigger?.addEventListener('click', () => {
            this.init();
        }, { once: true });
    }

    deleteLoader() {
        this.getRoot().innerHTML = '';
    }

    renderError() {
        this.getRoot().innerHTML = WarehouseProductDesk.errorMessage;
    }

    toggleCities() {
        const syncDataAttribute = 'data-city';

        const buttonActiveClass = WarehouseProductDesk.cn.setElem('btn').setMode({ active: true }).toString();
        const contentActiveClass = WarehouseProductDesk.cn.setElem('content').setMode({ active: true }).toString();

        const buttons = document.querySelectorAll<HTMLButtonElement>(WarehouseProductDesk.cn.setElem('btn').toSelector());
        const contents = document.querySelectorAll<HTMLDivElement>(WarehouseProductDesk.cn.setElem('content').toSelector());

        document.addEventListener('click', e => {
            const target = e.target as HTMLElement;

            if (target.closest(WarehouseProductDesk.cn.setElem('btn').toSelector())) {
                const button = target;

                const cityName = button.getAttribute(syncDataAttribute);
                const content = document.querySelector<HTMLDivElement>(WarehouseProductDesk.cn.setElem('content').toSelector() + `[${syncDataAttribute}="${cityName}"]`) as HTMLDivElement;

                buttons.forEach(i => i.classList.remove(buttonActiveClass));
                contents.forEach(i => i.classList.remove(contentActiveClass));

                button.classList.add(buttonActiveClass);
                content.classList.add(contentActiveClass);
            }
        });
    }

    async init() {
        try {
            const stock = await this.getStock(this.product.id);

            if (! stock) {
                throw new WarehouseProductDeskError('stock is empty');
            }

            const warehouseDate = this.transformStockData(stock);

            this.deleteLoader();
            this.renderTemplate({
                container: this.getRoot(),
                templateData: { data: warehouseDate }
            });
            this.toggleCities();
            // eslint-disable-next-line
        } catch (error: unknown) {
            if (! (error instanceof WarehouseProductDeskError)) {
                faro.api.pushError(error as Error, {
                    context: {
                        section: 'product page',
                        component: 'warehouse'
                    }
                });
            }

            this.renderError();
        }
    }
}
